import api from '../utils/api';

export const fetchCalendarComparison = async (year) => {
  const response = await api.get('/revenue/calendar-comparison', {
    params: { year }
  });
  return response.data;
};
export const fetchFinancialYearComparison = async (startYear) => {
  console.log("Fetching financial year comparison for start year:", startYear);
  const response = await api.get('/revenue/financial-year', {
    params: { startYear }
  });
  return response.data;
}
export const fetchInvoiceReportData = async (params) => {
    // Mapping UI labels to the procedure's required lowercase values
    const formattedParams = {
        rev_stream: params.revStream,
        fy: params.financialYear,
        sub_county_id: params.subCountyId || null,
        payment_status: params.paymentStatus.toLowerCase(),
        start_year: params.includeStart ? params.startYear : null,
        end_year: params.includeEnd ? params.endYear : null
    };

    const response = await api.post('/revenue/generate-invoice-data', formattedParams);
    return response.data;
};
export const fetchFinancialYears = async () => {
  const response = await api.get('/revenue/financial-years');
  return response.data;
};
export const fetchFYMRevenueReport = async (financialYear) => {
  const response = await api.get(`/revenue/fy-month-reports`, {
    params: { financialYear }
  });
  return response.data;
};
export const fetchFYMRevenueReport_Man = async (financialYear) => {
  const response = await api.get(`/revenue/fy-month-reports_man`, {
    params: { financialYear }
  });
  return response.data;
};
// import api from '../utils/api';

export const fetchRevenueStreams = async () => {
  const response = await api.get('/revenue/streams-lookup');
  return response.data;
};

export const fetchOtherRevenues = async (params) => {
  const response = await api.get('/revenue/other-revenues', { params });
  return response.data;
};

export const saveOtherRevenue = async (payload) => {
  const response = await api.post('/revenue/other-revenues', payload);
  return response.data;
};